import data from "../../utils/constants/data.json";
import CommonComponent from "../common-component/CommonComponent";

const BlogsComponent = () => {
    const { blogsData } = data;

    const blogsLayout = <CommonComponent items={blogsData} />;

    return blogsLayout;
};

export default BlogsComponent;
